import React from 'react';

import styles from 'buyside/components/presentation/TickerUploader/tickerUploadStyles.scss';

import { MassTickerSearch } from 'interfaces/graphql-typings';

const TickerUnfoundSymbols: React.FC<{
  unfoundSymbols: MassTickerSearch['unfoundSymbols'];
}> = ({ unfoundSymbols }): React.ReactElement => {
  return (
    <>
      <div className={styles.symbolInfo}>
        The following <strong>{unfoundSymbols?.length} </strong>
        ticker{unfoundSymbols?.length === 1 ? '' : 's'} had errors:
      </div>
      <div className={styles.unfoundSymbols}>
        {unfoundSymbols?.map(
          (symbol, idx): React.ReactElement => (
            <span className={styles.unfoundSymbol} key={idx}>
              <strong>{symbol}</strong>
            </span>
          )
        )}
      </div>
    </>
  );
};

export default TickerUnfoundSymbols;
